import { OBJECT_TYPES } from 'config';
import { getTravelAndExpenseIds } from './parseNumber';

export const defineTasksToUpdate = (task, taskId, objectTypeInView) => {
  if (objectTypeInView === OBJECT_TYPES.TRAVEL_AND_EXPENSE) {
    return [getTravelAndExpenseIds(taskId)];
  }
  return [task];
};
